import React, { useEffect, useState } from "react";
import { actionGetRptHistoricosDispositivos } from "../../../features/relatorios/rptHistoricosDispositivos/slices";
import factoryFields from "../../../helpers/factory-fields";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Button from "../../Button";
import SelectLojas from "../../DadosLojas/SelectLojas";
import Input from "../../Inputs";
import Select from "../../Select";

const RptHistoricoDispositivos = () => {
  const [state, setState] = useState<any>();
  const dispatch = useAppDispatch();
  const { getRptHistoricoDispositivos } = useAppSelector((state) => state);

  const [value, setValue] = useState("");

  const handlerChange = (e: any) => {
    setValue(e.target.value);
    const { name, value } = e.currentTarget;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handlerReport = () =>
    dispatch(actionGetRptHistoricosDispositivos(state));
  return (
    <div className="container">
      <div className="row">
        <div className="col-4">
          <div className="mb-20">
            <Select
              size="sm"
              label="Formato do arquivo"
              options={factoryFields.typesReport}
              value={value}
              onChange={handlerChange}
              name="reportType"
            />
            <Input
              type="date"
              size="sm"
              label="data Início"
              name="dataIni"
              onChange={handlerChange}
            />
            <Input
              type="date"
              size="sm"
              label="data Fim"
              name="dataFim"
              onChange={handlerChange}
            />
          </div>
          <Button
            size="sm"
            onClick={handlerReport}
            loading={getRptHistoricoDispositivos.status === "loading"}
          >
            Baixar Relatório
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RptHistoricoDispositivos;
